import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHurriyetemlakComponent } from './simple-icons-hurriyetemlak.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHurriyetemlakComponent ],
    exports:      [ SimpleIconsHurriyetemlakComponent ],
    bootstrap:    []
})
export class SimpleIconsHurriyetemlakModule {}
